export const types = {
    FREIGHTS_MASTER:"FREIGHTS_MASTER",
    FREIGHTS_MASTER_SUCCESS:"FREIGHTS_MASTER_SUCCESS",
}